import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useOutletContext } from 'react-router-dom';
import OperationalReporting from './OperationalReporting';

export default function ReportingRoute() {
  const { t } = useTranslation();
  const context = useOutletContext() || {};
  const { currentUser, userLoading } = context;

  if (userLoading) {
    return (
      <div className="route-loading-card" role="status" aria-live="polite">
        <div className="route-loading-shimmer" />
        <div>
          <strong>{t('route.reportingChecking')}</strong>
          <span>{t('route.reportingLoadingPermissions')}</span>
        </div>
      </div>
    );
  }

  if (!currentUser?.permissions?.reporting) {
    return <Navigate to="/dashboard/patients" replace />;
  }

  return <OperationalReporting />;
}
